export const VERIFICATION_CODE_LENGTH = 6;
